import { Component, EventEmitter, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogRef } from '@angular/material/dialog';
import { BnNgIdleService } from 'bn-ng-idle';
@Component({
  standalone: false,
  selector: 'app-session-refresh-dialog',
  templateUrl: './session-refresh-dialog.component.html',
  styleUrls: ['./session-refresh-dialog.component.css'],
  encapsulation: ViewEncapsulation.None 
})
export class SessionRefreshDialogComponent implements OnInit {

  @Input() displayModal: any;
  public onContinue: EventEmitter<any> = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<SessionRefreshDialogComponent>,
    private bnIdle: BnNgIdleService,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.displayModal = false;
    // // setTimeout(() => {
    // //   this.displayModal = false;
    // // }, 60000);
  }

  setTimer() {
    this.bnIdle.resetTimer();
    this.onContinue.emit({ isContinue: true });
  }

  refreshPage() {
   window.location.reload();

    //this.onContinue.emit({ isContinue: true });
  }
}
